import './styles/InputMonth.css';

import { Input } from '@chakra-ui/react';
import moment from 'moment';
import { useCallback, useEffect } from 'react';

import {
	defineBorderColorValue,
	defineInputValue,
} from './constants/inputsControl';
import { setInputsWithLocalstorage } from './constants/setInputsWithLocalstorage';
import { IInputs } from './models/InputsModel';

export const InputMonth = ({ ...others }: IInputs) => {
	const {
		dataTest,
		column,
		handleOnChange,
		inputValue,
		name,
		setInputValue,
		validation,
		localStorageValue,
		module,
	} = others;

	useEffect(() => {
		setInputsWithLocalstorage({
			column,
			localStorageValue,
			name,
			setInputValue,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const isRequiredInput = !!inputValue[name];

	const getMaxDate = useCallback(() => {
		if (
			module === 'orcamento' &&
			column === 'competencia' &&
			name === 'valorFinal'
		) {
			const today = moment();
			const maxDate = today.add(100, 'years').format('YYYY-MM');
			return maxDate;
		}
		const today = moment();
		const maxDate = today.add(1, 'year').format('YYYY-MM');
		return maxDate;
	}, [module, column, name]);

	return (
		<Input
			data-test={dataTest}
			className='input-month'
			type={'month'}
			borderRadius={'10px'}
			borderColor={defineBorderColorValue({
				name,
				validation,
			})}
			focusBorderColor='#e2e8f0'
			px={'0'}
			h={'3em'}
			fontSize={'12px'}
			name={name}
			onChange={event => handleOnChange(event)}
			value={defineInputValue({
				name,
				inputValue,
			})}
			max={getMaxDate()}
			style={{ marginRight: '14px' }}
			required={isRequiredInput}
		/>
	);
};
